import { editorPicks } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FeaturedSection() {
  const [lead, ...rest] = editorPicks;

  return (
    <section id="featured" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="EDITOR'S PICK"
            title="热播剧精选：本周值得先看的几部"
            desc="从正在更新的热播剧到刚上线的新片，编辑挑出关注度最高、口碑稳定的几部，附上一句话看点，方便你先决定从哪部开始。"
          />
          <a
            href="#series"
            className="inline-flex items-center gap-2 whitespace-nowrap self-start rounded-md border border-background-300/70 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:self-auto"
          >
            更多热播剧集
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 sm:flex-row">
            <div className="relative aspect-[3/4] w-full overflow-hidden sm:aspect-auto sm:w-2/5">
              <img
                src={lead.poster}
                alt={`${lead.title} 海报`}
                title={`${lead.title} 海报`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex w-full flex-col justify-between p-5 sm:w-3/5">
              <div>
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-900">
                    {lead.tag}
                  </span>
                  <span className="flex items-center gap-1 text-sm font-bold text-accent-700">
                    <i className="ri-star-fill"></i>
                    {lead.rating}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-950">{lead.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{lead.desc}</p>
              </div>
              <div className="mt-6 flex flex-wrap items-center gap-4">
                <a
                  href="#movies"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
                >
                  查看详情
                </a>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-bookmark-line"></i>
                  加入片单
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {rest.map((pick) => (
              <article
                key={pick.id}
                className="group flex gap-4 rounded-lg border border-background-200/70 bg-background-100 p-3 transition-colors hover:border-primary-200"
              >
                <div className="h-28 w-20 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={pick.poster}
                    alt={`${pick.title} 海报`}
                    title={`${pick.title} 海报`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-between">
                  <div>
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="truncate font-heading text-base font-bold text-foreground-950">{pick.title}</h3>
                      <span className="flex shrink-0 items-center gap-1 text-sm font-bold text-accent-700">
                        <i className="ri-star-fill"></i>
                        {pick.rating}
                      </span>
                    </div>
                    <span className="mt-1 inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs font-medium text-secondary-900">
                      {pick.tag}
                    </span>
                    <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{pick.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}